import { createContext } from "react";
import type { Participant, Position, GeolocationPosition, TenantApp } from "@inloco/shared";
import type { RoomSession, RoomSessionForJoining, RoomSessionWithoutId } from "../types/room-session";

export interface AppContextType {
    participants: Participant[];
    loadingOperationOnRoom: boolean;
    loadingGeolocation: boolean;
    position: GeolocationPosition | null;
    geolocationStatus: boolean;
    roomSession: RoomSession | null;
    isWithinBounds: boolean;
    handleRegistration: (sessionInfo: RoomSessionWithoutId) => void;
    handleLogout: () => void;
    handleJoinScannedRoom: (sessionForJoining: RoomSessionForJoining) => Promise<void>;
    handleAddBluetoothDevice: (macAddress: string, name: string) => Promise<void>;
    updatePosition: (app: TenantApp, position: Position, userId: string) => Promise<void>
}

export const AppContext = createContext<AppContextType | null>(null);